import { IconLoader2 } from "@tabler/icons-react";

export enum SpinnerSize {
  xl = "xl",
  l = "l",
  base = "base",
  s = "s",
  xs = "xs",
}

interface SpinnerProps {
  size?: SpinnerSize | `${SpinnerSize}`;
}

const dimensions: Record<SpinnerSize, string> = {
  xl: "h-12 w-12",
  l: "h-10 w-10",
  base: "h-8 w-8",
  s: "h-6 w-6",
  xs: "h-5 w-5",
};

const Spinner = ({
  size = SpinnerSize.base,
}: SpinnerProps) => (
  <IconLoader2 className={`animate-spin text-icon-bg-subtle ${dimensions[size]}`} />
);

export default Spinner;
